const operationTypeList = [
  { "value": 1, "text": "ログイン" },
  { "value": 2, "text": "登録" },
  { "value": 3, "text": "更新" },
  { "value": 4, "text": "削除" },
  { "value": 5, "text": "エクスポート" },
  { "value": 6, "text": "ダウンロード" },
];
export default {
  typeList: operationTypeList,
};